import { LIST_OF_APPS } from './utils/home.constants';
import { Subtitle, Title } from '@yaradigitallabs/ahua-react';
import AppList from './components/AppList';
import HeroSection from './components/Hero';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <div className="flex flex-col gap-4 px-6 py-6 md:px-14">
        <div className="flex flex-col">
          <Subtitle className="!text-sm !text-tertiary">E.FLOW APPS</Subtitle>
          <Title className="!text-2xl !font-black">
            Access your production apps
          </Title>
        </div>
        <AppList list={LIST_OF_APPS} />
      </div>
    </>
  );
};

export default HomePage;
